import { computed, type MaybeRefOrGetter, toValue } from 'vue'

import useNumber from '@/composables/number'

export interface HeaderCount {
  filtered: number
  total: number
}

export default function useHeaderCount(
  count: MaybeRefOrGetter<HeaderCount | null | undefined>,
  unitKey: MaybeRefOrGetter<string | null | undefined>
) {
  const { t } = useI18n()
  const { formatNumber } = useNumber()

  const value = computed<string | null>(() => {
    const resolved = toValue(count)
    if (!resolved || !toValue(unitKey)) return null

    return resolved.filtered === resolved.total
      ? `${formatNumber(resolved.total)}`
      : `${formatNumber(resolved.filtered)}/${formatNumber(resolved.total)}`
  })

  const label = computed(() => {
    const resolved = toValue(count)
    const key = toValue(unitKey)
    if (value.value === null || !resolved || !key) return null

    return `${value.value} ${t(key, resolved.total)}`
  })

  return { value, label }
}
